<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      实践案例试卷
    </div>
    <div class="padding-sm">
      <el-form :model="baseForm" ref="baseForm" label-width="120px">
        <el-form-item label="科目" prop="subject"
                      :rules="{required: true, message: '请选择科目', trigger: 'change'}"
        >
          <!--<el-select v-model="baseForm.subject" placeholder="请选择科目" style="width: 100%" :disabled="this.id">-->
            <!--<el-option-->
                <!--v-for="item in subjectList"-->
                <!--:key="item.id"-->
                <!--:label="item.name"-->
                <!--:value="item.id">-->
            <!--</el-option>-->
          <!--</el-select>-->
          <el-input  v-model="subject_name"  readonly> </el-input>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请输入试卷名称', trigger: 'blur'}]" label="试卷名称" prop="name">
          <el-input v-model="baseForm.name" placeholder="请输入试卷名称"></el-input>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请选择考试说明', trigger: 'change'}]" label="考试说明" prop="desc">
          <el-select v-model="baseForm.desc" placeholder="请选择考试说明" style="width: 100%">
            <el-option
                v-for="item in tipsList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请选择题目类别', trigger: 'change'}]" label="题目类别" prop="type">
          <el-select v-model="baseForm.type" placeholder="请选择题目类别" style="width: 100%">
            <el-option
                v-for="item in typeList"
                multiple
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请输入考试次数', trigger: 'change'}]" label="考试次数" prop="num">
          <el-input type="number" v-model.number="baseForm.num" placeholder="请输入考试次数" @blur="setNum"></el-input>

        </el-form-item>
        <el-form-item
            v-for="(domain,index) in baseForm.time"
            :key="index"
            :label="'第'+(index+1)+'场'"
            :prop="'time.' + index+ '.value'"
            :rules="{required: true, message: '请输入考试时间', trigger: 'change'}"
        >
          <div>
            <span></span>
            <el-date-picker
                style="width: 100%"
                v-model="domain.value"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="至"
                start-placeholder="考试开始日期"
                end-placeholder="考试结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请输入分组人数', trigger: 'change'}]" label="分组人数" prop="group_num">
          <el-input type="number" v-model.number="baseForm.group_num" placeholder="请输入分组人数"></el-input>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请输入第一次分组时间', trigger: 'change'}]" label="第一次分组时间"
                      prop="time1">
          <el-input type="number" v-model.number="baseForm.time1" placeholder="请输入第一次分组时间"></el-input>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请输入第二次分组时间', trigger: 'change'}]" label="第二次分组时间"
                      prop="time2">
          <el-input type="number" v-model.number="baseForm.time2" placeholder="请输入第二次分组时间（需小于第一次分组时间）"></el-input>
        </el-form-item>
        <el-form-item :rules="[{required: true, message: '请选择评分表', trigger: 'change'}]" label="评分表" prop="score">
          <el-select v-model="baseForm.score" multiple placeholder="请选择评分表" style="width: 100%">
            <el-option
                v-for="item in scoreList"
                multiple
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl submit-btn" type="primary" @click="submitForm('baseForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import {
  paperPracticeAdd,
  examExplainList,
    getExam,
  scoreList, questionTypeList, paperInfo
} from "@/api/projectOffice";

export default {
  name: "casePaperDialog",
  data() {
    return {
        subject_name: '',
      tipsList: [],
      typeList: [],
      scoreList: [],
      baseForm: {
        subject: '',
        name: '',
        desc: '',
        type: '',
        num: '',
        time: [],
        group_num: '',
        time1: '',
        time2: '',
        score: []
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 试卷列表 > 实践案例试卷",
        true
    );
    if (this.$route.query.id) this.id = this.$route.query.id
    this.init()
  },
  methods: {
    async getDetail() {
      let _data = await paperInfo(this.id, 2)
      this.baseForm = {
        subject: _data.data.subject_first_id,
        name: _data.data.title,
        desc: _data.data.explain_type,
        type: _data.data.type_id,
        num: _data.data.exam_address_num,
        time: [],
        group_num: _data.data.group_num,
        time1: _data.data.group_time,
        time2: _data.data.group_times,
        score:_data.data.score_id.split(',').map(Number)
      }
      this.$nextTick(() => {
        let _arr = _data.data.exam_nums_time.split('|')
        this.baseForm.time = []
        _arr.map(item => {
          item = item.split(',')
          this.baseForm.time.push({
            value: [new Date(item[0].replace(/-/g,'/')), new Date(item[1].replace(/-/g,'/'))]
          })
        })
      })

    },
    async init() {
      //  获取科目
      let _data = await getExam(this.$route.query.examid);
      this.subject_name= _data.data.subject_name;
      this.baseForm.subject= _data.data.subject_first;
      //  获取考试说明
      let _list2 = await examExplainList(1, 10000);
      this.tipsList = _list2.data.list;
      //  获取题目分类
      let _list3 = await questionTypeList(2, 1);
      this.typeList = _list3.data;
      //  获取评分表
      let _list4 = await scoreList('', 1, 10000);
      this.scoreList = _list4.data.list;

      if (this.id) await this.getDetail()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _arr = []
      this.baseForm.time.map(item => {
        item.value[0] = this.$tools.ZHDate(new Date(item.value[0]), 3)
        item.value[1] = this.$tools.ZHDate(new Date(item.value[1]), 3)
        _arr.push(item.value.join(','))
      })
      let _str = _arr.join('|')
      let _state = await paperPracticeAdd(
          this.$route.query.examid,
          this.baseForm.subject,
          this.baseForm.name,
          this.baseForm.desc,
          this.baseForm.type,
          this.baseForm.num,
          _str,
          this.baseForm.group_num,
          this.baseForm.time1,
          this.baseForm.time2,
          this.baseForm.score.join(','),
          this.id
      );
      this.$message.success(_state.msg);
      this.$router.go(-1)
    },
    setNum() {
      if (this.baseForm.num && this.baseForm.num > 0) {
        this.baseForm.time = []
        for (var i = 0; i < this.baseForm.num; i++) {
          this.baseForm.time.push({value: null})
        }
      } else {
        this.baseForm.time = []
      }
    }
  },
  watch: {
    'baseForm.num'() {

    }
  }
}
</script>

<style scoped lang="scss">

</style>